import React from "react";
import { Query } from "react-apollo";

import ListComments from "../../GraphQL/Query/ListComments";
import Comments from "../../GraphQL/Subscription/Comments";

import UserContext from "../../Contexts/UserContext";
import ListMessages from "./ListMessages";

class MessengerContent extends React.Component {
  render() {
    const { orderId, isNewMessage, setIsNewMessage } = this.props;
    return (
      <UserContext.Consumer>
        {({ profile }) => (
          <Query
            query={ListComments}
            fetchPolicy="cache-and-network"
            variables={{ orderId }}
          >
            {({ subscribeToMore, ...result }) => (
              <ListMessages
                {...result}
                isNewMessage={isNewMessage}
                setIsNewMessage={setIsNewMessage}
                user={profile}
                orderId={orderId}
                subscribeToComments={() =>
                  subscribeToMore({
                    document: Comments,
                    variables: { orderId },
                    updateQuery: (prev, { subscriptionData }) => {
                      if (!subscriptionData.data) return prev;
                      const newFeedItem =
                        subscriptionData.data.subscribeToComments;

                      const res = {
                        ...prev,
                        listComments: {
                          items: [
                            newFeedItem,
                            ...prev.listComments.items.filter(
                              item => item.id !== newFeedItem.id
                            )
                          ],
                          __typename: "CommentConnection",
                          nextToken: prev.listComments.nextToken
                        }
                      };

                      return res;
                    }
                  })
                }
              />
            )}
          </Query>
        )}
      </UserContext.Consumer>
    );
  }
}

export default MessengerContent;



// WEBPACK FOOTER //
// ./src/Components/Comments/MessengerContent.js